module.exports = __webpack_public_path__ + "static/media/welcomeimage1.2da4f6e3.jpg";